import Api from 'services/api';
import apiURLBuilder from 'core/apiURLBuilder';
import preLoaderActions from './preLoaderActions';
import { history } from 'routes/history';
import { BASE_PATH } from 'constants/index';

export const saveSignatureKey =
    ({ signatureKey, successCallback }) =>
    (dispatch, getState) => {
        const accessToken = getState().userProfile.accessToken;
        const request = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: { signatureKey },
        };

        dispatch(preLoaderActions.showPreLoader());
        Api.post(apiURLBuilder.getURL('saveSignatureKey'), request).then(
            () => {
                dispatch(preLoaderActions.hidePreLoader());
                successCallback();
            },
            () => {
                dispatch(preLoaderActions.hidePreLoader());
                history.push(BASE_PATH + '/errors');
            }
        );
    };
